const DarkTheme = {
  '--main-bg': 'black',
  '--main-text': 'whitesmoke',
  '--topbar-hover': '#ff6700',
  '--tooltip-bg': 'whitesmoke',
  '--tooltip-text': 'black',
  '--tooltip-border': 'black',
  '--tooltip-shadow': '0 0 10px 0px black',
  '--scrollbar-thumb': 'rgba(255, 255, 255, 0.5)',
  '--scrollbar-track': 'rgba(255, 255, 255, 0.2)',
}

export default DarkTheme
